<template>
  <div>
    <div class="searchDiv">
      <el-select v-model="params.platformId" clearable placeholder="请选择资金平台">
        <el-option v-for="(item, index) in platformList" :key="index" :label="item.name" :value="parseInt(item.id)"></el-option>
      </el-select>
      <el-input class="searchInput" v-model="params.name" placeholder="请输入产品名称" clearable></el-input>
      <el-button type="primary" @click="getProductPageList">查询</el-button>
      <el-button v-if="hasPer('prod:product:edit')" @click="addProduct()" style="float: right;">新增</el-button>
    </div>
    <el-table :data="tableData" row-key="id" border>
      <el-table-column label="产品名称" prop="name"/>
      <el-table-column label="资金平台" prop="platformName"/>
      <el-table-column label="月利率" prop="rates"/>
      <el-table-column label="期数" prop="duration"/>
      <el-table-column label="罚息" prop="interestPenalty"/>
      <el-table-column label="状态" prop="status">
        <template slot-scope="scope">
          {{ $dict.nameOf("start_stop", scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column label="描述" prop="describe" width="350"></el-table-column>
      <el-table-column label="操作" prop="option" width="280" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('prod:product:enabled')" :type="buttonType(scope.row.status)"
                     @click="enabledProduct(JSON.parse(JSON.stringify(scope.row)))">
            {{ "0" === scope.row.status ? "停用" : "启用" }}
          </el-button>
          <el-button v-if="hasPer('prod:product:enabled')" type="primary"
                     @click="addProduct(JSON.parse(JSON.stringify(scope.row)))">编辑
          </el-button>
          <el-button v-if="hasPer('prod:product:auth')" type="primary"
                     @click="authProduct(JSON.parse(JSON.stringify(scope.row)))">授权
          </el-button>
          <el-button v-if="hasPer('prod:product:del')" type="danger" @click="delProduct(scope.row.id, scope.row.name)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination :current.sync="params.current" :size.sync="params.size" :total="params.total" @get-list="getProductPageList"></pagination>
    <auth-product
        :auth-visible.sync="authVisible"
        :product-id="productId"
        :has-select-user-list="hasSelectUserList"
        @get-list="getProductPageList">
    </auth-product>
  </div>
</template>

<script>
import Pagination from "../../../components/Pagination.vue";
import {getProductPageList, enabledProduct, delProduct} from "../../../api/prod/product/product";
import {infoMsg, successMsg} from "../../../utils/message";
import {hasPer} from "../../../utils/common";
import authProduct from "@/views/prod/product/authProduct.vue";
import {getPlatformList} from "@/api/prod/platform/platform";

export default {
  name: "index",
  components: {
    Pagination, authProduct
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      params:{
        name: '',
        platformId: '',
        current: 1,
        size: 10,
        total: 0,
      },
      productObj: {},
      authVisible: false,
      productId: null,
      platformList:[],
      hasSelectUserList:[]
    }
  },
  mounted() {
    this.getProductPageList()
    this.getPlatformList()
  },
  methods: {
    hasPer,
    getProductPageList() {
      getProductPageList({...this.params}).then(res => {
        this.tableData = res.records
        this.params.total = res.total
        this.params.size = res.size
        this.params.current = res.current
      })
    },
    getPlatformList(){
      getPlatformList().then(res => {
        this.platformList = res
      })
    },
    addProduct(row) {
      this.$router.push({
        path: row ? `${this.$route.path}/editProduct?id=${row.id}` : `${this.$route.path}/editProduct`
      });
    },
    authProduct(row){
      this.authVisible = true
      this.productId = row.id
      this.hasSelectUserList = row.productAuthList
    },
    delProduct(id, username) {
      this.$confirm('确定删除用户【' + username + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delProduct({id: id}).then(() => {
          successMsg('操作成功')
          this.getProductPageList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    //  启用/停用用户
    enabledProduct(row) {
      let paramss = {
        id: row.id,
        status: row.status = "0" === row.status ? "1" : "0"
      }
      const str = "0" === row.status ? '停用' : '启用'
      this.$confirm('确定<span >' + str + '</span>产品【' + row.name + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        enabledProduct(paramss).then(() => {
          successMsg('操作成功')
          this.getProductPageList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    buttonType(type) {
      if (type) {
        return 'warning'
      } else {
        return 'success'
      }
    }
  }
}
</script>

<style scoped>
.searchDiv{

  .el-select{
    width: 200px;
  }
}
</style>